import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Editor } from './Editor';
import type { Ubicacion } from './api';
import { aplicarMarca, cargarMarca } from './marca';
import { aplicarTema, parseTema, temaGuardadoLocal } from './tema';
import './styles.css';

// Antes del primer render, para no mostrar un destello con el tema equivocado
// mientras /me viaja.
const { modo, paleta } = parseTema(temaGuardadoLocal());
aplicarMarca();
aplicarTema(modo, paleta);
void cargarMarca();

const root = document.getElementById('root');
if (!root) throw new Error('Falta el nodo #root en index.html');

// El editor abre en su propia pestaña, a pantalla completa y sin el resto de
// la interfaz. No hace falta un router para una sola ruta más.
function ubicacionDelEditor(): Ubicacion | null {
  if (window.location.pathname !== '/editar') return null;
  const q = new URLSearchParams(window.location.search);
  const key = q.get('key');
  const path = q.get('path');
  if (key) return { key };
  if (path) return { path };
  return null;
}

const ubicacion = ubicacionDelEditor();

createRoot(root).render(
  <StrictMode>{ubicacion ? <Editor ubicacion={ubicacion} /> : <App />}</StrictMode>,
);
